module.exports = __webpack_public_path__ + "img/fblc-国际赛区.5918ca53.jpg";